import React from 'react'
import { AuthContext } from './auth-context'

/**
 * Hook to access the auth context
 * @returns Auth context values (userType, isLoading, error)
 */
export function useAuth() {
  return React.use(AuthContext)
}
